import {inject, observer} from 'mobx-react';
import React, {useContext, useEffect, useState} from 'react';
import styled from 'styled-components';
import {ThemeContext} from '../../apiContexts';
import I18nMessage from '../../components/I18nMessage';
import {formatEventTime} from '../../helpers/date';
import {PlatformIntl} from '../../infra/PlatformIntl';
import {colors, shadows} from '../../styleVariables';

const EventType = styled.h6`
  font-weight: bold;
  margin-bottom: 0.2rem;
`;

const Date = styled.span``;

const Address = styled.small`
  color: ${colors.gray};
`;

const Popup = styled.div`
  background-color: white;
  padding: 0.7rem;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: ${shadows.shadow};
  flex-direction: column;
  display: ${({show}) => (!show ? 'none' : 'flex')};

  ${EventType} {
    color: ${({theme}) => theme};
  }

  ${Date} {
    color: ${({theme}) => theme};
  }
`;

const getEvent = (type, attributes) => {
  return attributes.alarm ?
    `alarm${String(attributes.alarm)
        .charAt(0)
        .toUpperCase()}${String(attributes.alarm).slice(1)}` :
    `event${String(type)
        .charAt(0)
        .toUpperCase()}${String(type).slice(1)}`;
};

// Sem conversao de fuso: o horario do evento e mostrado no fuso de quem esta olhando, igual ao card
// da lista e igual ao aplicativo. Converter para o fuso configurado na conta fazia a mesma hora
// aparecer diferente em cada tela.
export const formatEventDate = (event) =>
  formatEventTime(event, PlatformIntl.getInstance().formatMessage('dateTimeLongFormat'));

const PopupEvent = ({server, events, isEvent, ...props}) => {
  const theme = useContext(ThemeContext);

  const [show, setShow] = useState(false);

  const {current, position} = events || {};
  const {type} = current || {};
  const {attributes} = current || {};

  useEffect(() => {
    current && setShow(true);
  }, [current]);

  return (
    <Popup id="popupEvent" theme={theme} show={show && isEvent}>
      {current && (
        <>
          <EventType>
            <I18nMessage id={getEvent(type, attributes)} />
          </EventType>
          <Date>{formatEventDate(current)}</Date>
          {/* Evento de aparelho offline, resultado de comando e manutencao nao tem posicao, logo nao
              tem endereco -- mas o tipo e o horario continuam valendo e precisam aparecer. */}
          {position && <Address>{position.address}</Address>}
          <span>{attributes.result}</span>
        </>
      )}
    </Popup>
  );
};

const mapping = ({store}) => ({
  server: store.server,
  events: store.events,
});

export default inject(mapping)(observer(PopupEvent));
